export default "__VITE_ASSET__BGDuc05T__"